import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IMyMonitoringAccountModel } from '@apps-common/types/portal/my-monitoring'

export const QUERY_KEY_GET_MY_MONITORING_ACCOUNT = (id?: number) => ['getMyMonitoringAccount', id].filter(Boolean)

export const getMyMonitoringAccount = async (id: number): Promise<IMyMonitoringAccountModel> =>
  axios.get(`/MyMonitoringAccountManagement/GetAccount?id=${id}`).then((res) => res.data?.data)

type QueryFnType = typeof getMyMonitoringAccount

type Props = {
  config?: QueryConfig<QueryFnType>
  id: number
}

export const useGetMyMonitoringAccount = ({ config, id }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_GET_MY_MONITORING_ACCOUNT(id),
    queryFn: () => getMyMonitoringAccount(id)
  })
